export default __webpack_public_path__ + "2e6f1c161eb33999d27bef2cd3afc624.ico";